"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchChangeStatus = batchChangeStatus;
exports.cacheById = cacheById;
exports.changeGroupStatus = changeGroupStatus;
exports.changeStatus = changeStatus;
exports.changeStoreGroupItemEstimateFlag = changeStoreGroupItemEstimateFlag;
exports.deleteStoreTemplate = deleteStoreTemplate;
exports.downloadGoodsShelfTemplate = downloadGoodsShelfTemplate;
exports.downloadGroupShelfTemplate = downloadGroupShelfTemplate;
exports.downloadImportTemplate = downloadImportTemplate;
exports.generateStoreMenuPreviewQrCode = generateStoreMenuPreviewQrCode;
exports.getById = getById;
exports.getStoreGroupItem = getStoreGroupItem;
exports.getStoreTemplateGroup = getStoreTemplateGroup;
exports.getStoreTemplateGroupItems = getStoreTemplateGroupItems;
exports.importExcel = importExcel;
exports.importGoodsShelfExcel = importGoodsShelfExcel;
exports.importGroupShelfExcel = importGroupShelfExcel;
exports.queryList = queryList;
exports.saveStoreGroupItem = saveStoreGroupItem;
exports.saveStoreTemplate = saveStoreTemplate;
exports.updGroupShelfStatus = updGroupShelfStatus;
exports.updXyMenuStoreTemplate = updXyMenuStoreTemplate;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
//修改明细估清状态
function changeStoreGroupItemEstimateFlag(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/changeStoreGroupItemEstimateFlag',
    method: 'post',
    data: data
  });
}

// 缓存菜单
function cacheById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/cacheById/' + id,
    method: 'get'
  });
}

// 批量更新状态
function batchChangeStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/batchChangeStatus',
    method: 'post',
    data: data
  });
}

// 查询明细id
function getStoreGroupItem(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/getStoreGroupItem/' + id,
    method: 'get'
  });
}

// 保存分组明细
function saveStoreGroupItem(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/saveStoreGroupItem',
    method: 'post',
    data: data
  });
}

// 获取模板关联的分组列表
function getStoreTemplateGroupItems(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/getStoreTemplateGroupItems',
    method: 'get',
    params: query
  });
}

// 获取模板关联的分组列表
function getStoreTemplateGroup(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/getStoreTemplateGroup',
    method: 'get',
    params: query
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/' + id,
    method: 'get'
  });
}

// 解除绑定
function deleteStoreTemplate(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/deleteXyMenuStoreTemplate?id=' + id,
    method: 'get'
  });
}

// 列表
function changeStatus(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/changeStatus',
    method: 'get',
    params: query
  });
}

// 绑定新模板
function saveStoreTemplate(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/saveXyMenuStoreTemplate',
    method: 'post',
    data: data
  });
}

// 列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/page',
    method: 'get',
    params: query
  });
}

// 商品上下架
function updXyMenuStoreTemplate(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/updXyMenuStoreTemplate',
    method: 'post',
    data: data
  });
}

// 下载导入模板
function downloadImportTemplate(operation) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/downloadImportTemplate',
    method: 'get',
    params: {
      operation: operation
    },
    responseType: 'blob'
  });
}

// 导入Excel
function importExcel(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/importExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 下载商品上下架导入模板
function downloadGoodsShelfTemplate() {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/downloadGoodsShelfTemplate',
    method: 'get',
    responseType: 'blob'
  });
}

// 导入商品上下架Excel
function importGoodsShelfExcel(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/importGoodsShelfExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 生成门店菜单预览二维码
function generateStoreMenuPreviewQrCode(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/generatePreviewQrCode',
    method: 'post',
    data: data
  });
}

// 修改门店模板分组状态
function changeGroupStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/changeGroupStatus',
    method: 'post',
    data: data
  });
}

// 分组上下架操作
function updGroupShelfStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/updGroupShelfStatus',
    method: 'post',
    data: data
  });
}

// 下载分组上下架导入模板
function downloadGroupShelfTemplate() {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/downloadGroupShelfTemplate',
    method: 'get',
    responseType: 'blob'
  });
}

// 导入分组上下架Excel
function importGroupShelfExcel(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuStoreTemplate/importGroupShelfExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}